<template>
    <div class="page-sessions">
        <div class="container">
            <div class="inner">
                <h1 class="title title--h1 title--separator">{{ $t('auth.sessionsPage.title') }}</h1>

                <div class="filter-options">
                    <div class="form_input--checkbox form_input">
                        <div class="field-ctn field-border-gradient">
                            <input
                                type="checkbox"
                                v-model="showPastSessions"
                                class="apple-switch"
                                id="showPastSessions"
                                name="showPastSessions"
                            />
                            <label for="showPastSessions">
                                Afficher les sessions passées
                            </label>
                        </div>
                    </div>
                </div>

                <div v-if="filteredSessions.length" class="list-sessions">
                    <div
                        v-for="session in filteredSessions"
                        :key="session._id"
                        :class="{ 'session-past': isSessionPast(session) }"
                    >
                        <CardSession @clicked="selectSession" :session="session" />
                    </div>
                </div>
                <div v-else class="empty-sessions">
                    <h2 class="title-h2">
                        {{ $t('generic.noresult') }}
                    </h2>
                </div>
            </div>
            <SessionLogoutVue />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useEventStore } from '@/stores/EventStore';
import CardSession from '@/components/molecules/CardSession.vue';
import SessionLogoutVue from '@/components/atoms/SessionLogout.vue';
import { useUserStore } from '@/stores/UserStore';
import { toast } from 'vue3-toastify';
import { EventSession } from '@/interfaces/EventSession';
    const eventStore = useEventStore()
    const route = useRoute()
    const router = useRouter()
    const userStore = useUserStore()
    const filterText = ref(null)
    const showPastSessions = ref(false)

    const filterList = (val: any) => {
        filterText.value = val
    }

    onMounted(async () => {
        const id = String(route.params.eventId)
        await eventStore.fetchEventsSession(id)
    })

    const isSessionPast = (session: EventSession): boolean => {
        const sessionDate = new Date(session.date)
        const now = new Date()
        const twoHoursAgo = new Date(now.getTime() - 12 * 60 * 60 * 1000)
        return sessionDate < twoHoursAgo
    }

    const filteredSessions = computed(() => {
        if (!eventStore.sessions) {
            return []
        }
        return eventStore.sessions
            ?.filter((el: EventSession) => {
                // Filter by text
                if (filterText.value) {
                    let sampleRegEx = new RegExp(`${filterText.value}`, 'gmi')
                    if (!sampleRegEx.test(el.name)) {
                        return false
                    }
                }

                // Filter by past sessions
                if (!showPastSessions.value && isSessionPast(el)) {
                    return false
                }

                return true
            })
            .sort((a: EventSession, b: EventSession) => {
                // Sort by date ascending (oldest first)
                const dateA = new Date(a.date).getTime()
                const dateB = new Date(b.date).getTime()
                return dateA - dateB
            })
    })

    const selectSession = async (session: EventSession) => {
        try {
            eventStore.currentSession = session
            if (eventStore.currentEvent) {
                router.push({name: 'ticket', params: { eventId: eventStore.currentEvent._id}});
            }
        } catch (error) {
            toast.error('Impossible de créer une session de vente')
        }
    }

</script>

<style scoped>
.filter-options {
    margin: 20px 0;
}

.session-past {
    opacity: 0.8;
}
</style>